module.exports = __webpack_public_path__ + "img/point3_screen_flow3.182521db.png";